import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';

import { intlShape, injectIntl, defineMessages } from 'react-intl';

import _ from 'lodash';
import isLoggedIn from '../../helpers/checkAuth';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import Link from '../Link';
import SkholeIcon11White from '../statelessComponents/Icons/SkholeIcon11White';
import SkholeIcon11 from '../statelessComponents/Icons/SkholeIcon11';

import s from './QuizzesListItem.scss';
import {
  isUserFromWhitelabeledOrganization,
  userSkillEvaluationEnabled,
} from '../../helpers';

const messages = defineMessages({
  finishQuizTitle: {
    id: 'QuizListItem.finishTitle',
    defaultMessage: 'Finished quiz',
    description: 'Finished quiz title text',
  },
  notStartedQuizTitle: {
    id: 'QuizListItem.notStartedTitle',
    defaultMessage: 'Not started quiz',
    description: 'Not started quiz title text',
  },
  notAvailableOffline: {
    id: 'QuizListItem.notAvailableOffline',
    defaultMessage: 'Not available offline',
  },
  notAvailableInOfflineMode: {
    id: 'QuizListItem.notAvailableInOfflineMode',
    defaultMessage: 'Not available in offline mode',
  },
  archived: {
    id: 'QuizListItem.archived',
    defaultMessage: 'Archived',
  },
});

@injectIntl
@withStyles(s)
@connect(state => ({
  auth: state.auth,
  lang: state.intl.locale,
  offline: state.online.offline,
}))
export default class QuizzesListItem extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired, // eslint-disable-line
    course: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      isAvailable: PropTypes.bool.isRequired,
      completedLessons: PropTypes.number,
      completedQuizzes: PropTypes.number,
      progress: PropTypes.number,
    }).isRequired,
    item: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isAvailable: PropTypes.bool.isRequired,
      removed: PropTypes.instanceOf(Date),
    }).isRequired,
    active: PropTypes.bool,
    intl: intlShape.isRequired,
    isCompleted: PropTypes.bool,
    offline: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
    isCompleted: undefined,
    disabled: false,
  };

  state = {
    isRestrictedAccessModalOpened: false,
  };

  hasAccess = () => {
    const { auth, course } = this.props;

    return isLoggedIn(auth) && course.isAvailable;
  };

  checkAuth = event => {
    if (this.hasAccess()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isRestrictedAccessModalOpened: true,
    });
  };

  closeRestrictedAccessModal = () => {
    this.setState({
      isRestrictedAccessModalOpened: false,
    });
  };

  render() {
    const {
      item,
      auth,
      course,
      active,
      intl: { formatMessage },
      isCompleted,
      offline,
      disabled,
    } = this.props;
    const { isRestrictedAccessModalOpened } = this.state;

    const completedSectionItemsNumber =
      course.completedLessons + course.completedQuizzes;
    const isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
    const isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);

    const showEvaluationModal =
      (!isWhitelabeled || isUserSkillEvaluationEnabled) &&
      !_.get(course, 'isUserSkillEvaluated') &&
      !course.progress &&
      !completedSectionItemsNumber &&
      !offline &&
      isLoggedIn(auth);

    let listItem = (
      <ListItem
        data-test-id="ICbU7WVGlauVeGkjMFqBx"
        className={classNames(s.quizListItem, active ? s.active : undefined, {
          [s.archived]: !!item.removed,
        })}
        component={this.hasAccess() ? Link : 'div'}
        to={`/courses/${course.slug}/quizzes/${item._id}${
          showEvaluationModal ? '?showEvaluationModal' : ''
        }`}
        disabled={offline || disabled}
        onClick={this.checkAuth}
        button
      >
        <ListItemIcon classes={{ root: s.quizListItemRoot }}>
          {active ? (
            <SkholeIcon11White color="#fff" className={s.startQuizIcon} />
          ) : (
            <SkholeIcon11 className={s.startQuizIcon} />
          )}
        </ListItemIcon>
        <ListItemText
          primary={item.name}
          secondary={
            <>
              {offline && (
                <div>{formatMessage(messages.notAvailableOffline)}</div>
              )}
              {!!item.removed && <div>{formatMessage(messages.archived)}</div>}
            </>
          }
          classes={{
            root: s.quizTitleTextWrapper,
            primary: s.quizTitleTextPrimary,
            secondary: s.quizTitleTextSecondary,
          }}
        />
        <ListItemSecondaryAction className={s.secondaryAction}>
          {isCompleted && isLoggedIn(auth) && (
            <Tooltip
              id="tooltip-finished"
              title={formatMessage(messages.finishQuizTitle)}
            >
              <div className={s.completedIcon} />
            </Tooltip>
          )}
          {isCompleted === false && isLoggedIn(auth) && (
            <Tooltip
              id="tooltip-not-started"
              title={formatMessage(messages.notStartedQuizTitle)}
            >
              <div className={s.notCompletedIcon} />
            </Tooltip>
          )}
        </ListItemSecondaryAction>
      </ListItem>
    );

    if (offline) {
      listItem = (
        <Tooltip title={formatMessage(messages.notAvailableOffline)}>
          <div>{listItem}</div>
        </Tooltip>
      );
    }

    return (
      <div>
        {listItem}
        <Modal
          open={isRestrictedAccessModalOpened}
          onClose={this.closeRestrictedAccessModal}
        >
          <RestrictedAccessModal onClose={this.closeRestrictedAccessModal} />
        </Modal>
      </div>
    );
  }
}
